<div class="fixedOnlyWeb" style="display:flex;z-index: 1000"
     #CONTAINER >
    <ng-content>

    </ng-content>
</div>
<div [ngStyle]="{width:widthContainer,height:heigthContainer}" class="visualized-in-desktop">
</div>
